<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<div class="card mt-5 text-info" style="background-color: #263238">
		<div class="card-body">
			<h1 class="card-title border-bottom mb-5">Sign Up</h1>
			<form @submit.prevent="submitUserSignUpData">
				<div class="row g-2">
					<div class="form-floating">
						<input
							type="email"
							class="form-control"
							id="floatingInputGrid"
							placeholder="name@example.com"
							v-model.trim="signUpEmail.val"
						/>
						<label for="floatingInputGrid">Email address</label>
					</div>
					<div class="form-floating">
						<input
							type="password"
							class="form-control"
							id="floatingPassword"
							placeholder="Password"
							v-model.trim="signUpPassword.val"
						/>
						<label for="floatingPassword">Password</label>
					</div>
				</div>
				<div class="mt-2">
					<button
						:disabled="isLoading"
						class="btn btn-outline-info btn-lg me-4"
					>
						<div v-show="isLoading">
							<i class="fa-solid fa-baseball fa-spin"></i>
							Loading...
						</div>
						<div v-show="!isLoading">Next</div>
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import LoginForm from "@/components/auth/LoginForm.vue";
export default {
	components: {
		LoginForm,
	},
	emits: ["signup-step-complete", "signup-form-data"],
	data() {
		return {
			userType: {
				val: "",
				isValid: true,
			},
			signUpEmail: {
				val: "",
				isValid: true,
			},
			signUpPassword: {
				val: "",
				isValid: true,
			},
			formIsValid: true,
			error: null,
			isLoading: false,
			showLoginForm: false,
		};
	},
	methods: {
		validateForm() {
			if (this.signUpEmail.val === "") {
				this.signUpEmail.isValid = false;
				this.formIsValid = false;
			}
			if (
				this.signUpPassword.val === "" ||
				this.signUpPassword.val.length < 6
			) {
				this.signUpPassword.isValid = false;
				this.formIsValid = false;
			}
		},
		clearValidity(input) {
			this[input].isValid = true;
		},
		// async submitSignUpForm() {
		// 	this.isLoading = true;
		// 	this.validateForm();
		// 	if (!this.formIsValid) {
		// 		return;
		// 	}

		// 	const payload = {
		// 		email: this.signUpEmail.val,
		// 		password: this.signUpPassword.val,
		// 	};
		// 	this.$emit("signup-form-data", payload);
		// 	this.$emit("signup-step-complete");
		// 	this.isLoading = false;
		// },
		async submitUserSignUpData() {
			this.validateForm();
			if (!this.formIsValid) {
				return;
			}
			this.isLoading = true;
			const payload = {
				email: this.signUpEmail.val,
				password: this.signUpPassword.val,
			};
			try {
				await this.$store.dispatch("signup", payload);
				this.$emit("signup-form-data", payload);
				this.$emit("signup-step-complete");
			} catch (err) {
				this.error = err.message || "Set user info failed... Try again.";
			}
		},
		showForm(){
			this.showLoginForm = true
		},
		closeLoginForm(){
			this.showLoginForm = false
		},
		handleError() {
			this.error = null;
		},
	},
};
</script>

<style>
.form-floating label {
	color: #39c0ed !important;
}

.form-floating label.active {
	color: #39c0ed !important;
}

.form-floating input {
	color: #39c0ed !important;
	border: 0.5px solid #39c0ed !important;
	background-color: #212529;
}

.form-floating input:focus {
	border: 3px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
	background-color: #212529;
}

.form-floating select {
	color: #39c0ed !important;
	border: 0.5px solid #39c0ed !important;
	background-color: #212529;
}

.form-floating select:focus {
	border: 2px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
}
.form-outline textarea,
input {
	color: #39c0ed !important;
	border: 0.5px solid #39c0ed !important;
	background-color: #212529;
}

.form-outline textarea:focus,
input {
	border: 2px solid #39c0ed !important;
	box-shadow: 0 1px 0 0 #39c0ed !important;
	color: #39c0ed !important;
	background-color: #212529;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	-webkit-box-shadow: 0 0 0 30px #212529 inset !important;
	-webkit-text-fill-color: #39c0ed;
}
</style>
